import { styled } from 'stitches.config'

export const ScoopServeBannerRoot = styled('div', {
  background: '$primary-700',
  width: '100%',
  padding: '$6 $3',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '@bp2': {
    padding: '$8 $4',
  },
})

export const Tagline = styled('p', {
  fontFamily: '$display',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  color: '$accent-white',
  textAlign: 'center',
  maxWidth: '600px',

  '@bp2': {
    fontSize: '$h2',
    lineHeight: '$h2',
    letterSpacing: '$h2',
  },
})
